import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Drawer, Empty, Form, Input, Spin } from 'antd';
import React, { useMemo, useState } from 'react';
import { useGetCategoriesAttributes } from '../../../../../utils/api/categories/useGetCategoriesAttributes';

const Attributes = ({ category }) => {
  const [selectedAttribute, setSelectedAttribute] = useState({});
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { attributes, isLoading } = useGetCategoriesAttributes(category?.id);

  const onClose = () => {
    setOpen(false);
    setSelectedAttribute({});
  };

  const handleShowDetails = ({ attribute }) => {
    setOpen(true);
    setSelectedAttribute(attribute);
  };

  const technicalAttributes = attributes?.technical_attributes || [];

  const filteredAttributes = useMemo(() => {
    if (!search) return technicalAttributes;

    return technicalAttributes.filter((attribute) => {
      const searchLower = search.toLowerCase();
      return (
        attribute.name?.toLowerCase().includes(searchLower) ||
        attribute.label?.toLowerCase().includes(searchLower)
      );
    });
  }, [technicalAttributes, search]);

  if (isLoading) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (technicalAttributes.length === 0) {
    return (
      <div style={{ padding: '24px' }}>
        <Empty description="Aucun attribut technique disponible" />
      </div>
    );
  }

  return (
    <div style={{ paddingBottom: '16px' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: '#fff',
          padding: '8px 0',
        }}
      >
        <Input
          placeholder="Rechercher un attribut par nom ou libellé..."
          prefix={<SearchOutlined />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
        />
      </div>
      {filteredAttributes.length === 0 ? (
        <Empty description="Aucun attribut ne correspond à votre recherche" />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {filteredAttributes.map((attribute, index) => (
            <div
              key={`${attribute.name}-${index}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px',
                border: '1px solid #f0f0f0',
                borderRadius: '6px',
                backgroundColor: '#fafafa',
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    color: '#262626',
                    marginBottom: '4px',
                  }}
                >
                  {attribute.label}
                </div>
                <div style={{ fontSize: '13px', color: '#8c8c8c' }}>
                  {attribute.name}
                </div>
              </div>
              <Button
                icon={<InfoCircleOutlined />}
                onClick={() => handleShowDetails({ attribute })}
              >
                Détails
              </Button>
            </div>
          ))}
        </div>
      )}
      <Drawer
        title="Détails"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}
        width={500}
      >
        <Form layout="vertical">
          <Form.Item label="Variable" name="name">
            <Input placeholder={selectedAttribute?.name} disabled />
          </Form.Item>
          <Form.Item label="Libellé" name="label">
            <Input placeholder={selectedAttribute?.label} disabled />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default Attributes;
